/**
 * Напоминание подтвердить адрес.
 *
 * Показывается вошедшему игроку, пока адрес не подтверждён. Без него человек
 * упирался бы в отказ на первой же попытке сыграть и не понимал, почему.
 */
import { Trans, useTranslation } from "react-i18next";
import { useState } from "react";

import { ApiError } from "../api/client";
import { useResendVerification } from "../api/queries";
import { useAuthStore } from "../stores/authStore";

export function VerificationBanner() {
  const user = useAuthStore((state) => state.user);
  const status = useAuthStore((state) => state.status);
  const resend = useResendVerification();
  const { t } = useTranslation();

  const [notice, setNotice] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  if (status !== "authenticated" || !user || user.emailVerified) return null;

  const send = () => {
    setNotice(null);
    setFailed(false);

    resend.mutate(undefined, {
      onSuccess: () => setNotice(t("verify.sent", { email: user.email })),
      onError: (error) => {
        setFailed(true);
        setNotice(
          error instanceof ApiError
            ? error.message
            : t("verify.failed"),
        );
      },
    });
  };

  return (
    <div className="border-b border-amber-400/25 bg-amber-400/10">
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2.5">
        <span className="text-sm text-amber-100">
          <Trans i18nKey="verify.banner" values={{ email: user.email }}
            components={{ mail: <span className="font-semibold" /> }} />
        </span>

        <button
          type="button"
          className="btn-secondary ml-auto shrink-0 px-3 py-1.5 text-xs"
          disabled={resend.isPending}
          onClick={send}
        >
          {resend.isPending ? t("verify.sending") : t("verify.resend")}
        </button>

        {notice && (
          <span className={`w-full text-xs ${failed ? "text-rust" : "text-sage"}`}>{notice}</span>
        )}
      </div>
    </div>
  );
}
